import { DESCENDING } from 'constants/sortDirections';
import { arrayToObject } from 'utils/helpers';
// import { TableColumn } from './types';

/**
 * Filtering the rows by the active filter string requires concatenating the searchable text fields on each row and then checking to see if they includes the search filter
 * @param {any[]} columns - columns in the table with a .searchable key/value pair
 * @param {any[]} rows - the rows in the table
 * @param {string} filter - the text to filter by
 */
export const filterRows = (columns = [], rows = [], filter = '') =>
  rows.filter((row) => {
    const searchProps = columns.reduce((acc, col) => {
      if (!col.searchable) {
        // return early to skip non-searchable columns
        return acc;
      }

      // build up the string using the row data for each column
      return acc.concat(row[col.value]);
    }, '');

    // check if the accumulated values include the value we're filtering by
    return searchProps.toLowerCase().includes(filter.toLowerCase());
  });

/**
 * Split columns array into Primary and Others
 * For mobile views we need to be able to get a primary column item for the header, and then the rest
 * keep their order
 */
// type SplitTableColumnsArg = {
//   columns: TableColumn[],
//   key: string, // the name of the property to search
//   value: string, // the value of the property to match
// };
// type SplitTableColumnsReturn = [TableColumn, TableColumn[]];
export const splitTableColumns = (
  {
    columns,
    key = 'name', // the default ID of a table column is the 'name'
    value,
  } /*: SplitTableColumnsArg */,
) /*: SplitTableColumnsReturn */ =>
  columns.reduce(
    (acc, col) => {
      if (col[key] === value) {
        return [col, acc[1]];
      }
      return [acc[0], acc[1].concat(col)];
    },
    [undefined, []],
  );

/**
 * Sort objects by a value and direction
 * @param {any[]} objectArray - an array of objects
 * @param {string} sortedBy  - the values to sort by
 * @param {string} sortDirection - ASCENDING or DESCENDING, DESCENDING is default
 */
export const sortByObjValue = (objectArray = [], sortKey = '', sortDirection = DESCENDING) =>
  objectArray.sort((val1, val2) => {
    let formattedValue1 = val1[sortKey];
    let formattedValue2 = val2[sortKey];
    if (typeof formattedValue1 === 'string' && typeof formattedValue2 === 'string') {
      formattedValue1 = formattedValue1.toLowerCase();
      formattedValue2 = formattedValue2.toLowerCase();
    }
    if (sortDirection === DESCENDING) {
      return formattedValue1 > formattedValue2 ? -1 : 1;
    }
    return formattedValue2 > formattedValue1 ? -1 : 1;
  });

/**
 * getColumns
 * Helper function to get the available columns. Filters out any hidden columns.
 * @returns { Array } The available columns to show in the table.
 */
export const getColumns = (columns, visibleColumns) => {
  if (visibleColumns?.length) {
    const columnsObject = arrayToObject(columns, 'value');
    const columnsToDisplay = [];
    visibleColumns.forEach((visibleColumn) => {
      if (columnsObject[visibleColumn]) {
        columnsToDisplay.push(columnsObject[visibleColumn]);
      }
    });
    return columnsToDisplay;
  }
  return columns;
};
